// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import { formFieldLabelStyles } from "@store/Themes/common/mixins/formField";
import { productDetailsFormWrapperStyles } from "@store/Themes/common/mixins/productDetails";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import ShoppingCartLine from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartLine";
import { visuallyHiddenStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

const labelProps = {
    css: css`
        ${formFieldLabelStyles()}
        font-size: ${x => x.theme.design.typography.size.smaller};
        ${visuallyHiddenStyles()}/* Store Custom Code */
    `,
};

export interface ProductDetailsAddToCartOptionsAndButtonStyles {
    addToCartOptionAndButton?: AddToCartOptionsAndButtonStyles;
}

export const productDetailsAddToCartOptionsAndButtonStyles: ProductDetailsAddToCartOptionsAndButtonStyles = {
    addToCartOptionAndButton: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: productDetailsFormWrapperStyles(),
                },
            },
        },
        quantityOrdered: {
            extendedStyles: {
                labelProps,
                cssOverrides: {
                    inputSelect: css`
                        /* Store Custom Code - Start */
                        width: ${pxToRem(90)};
                        height: ${pxToRem(52)};
                        &,
                        &:focus,
                        &:focus-within {
                            border-radius: ${x => x.theme.design.common.contentRadius};
                            border-width: ${pxToRem(1)};
                        }
                        /* Store Custom Code - End */
                    `,
                },
            },
        },
        unitOfMeasure: {
            extendedStyles: {
                labelProps,
            },
        },
        // Store Custom Code
        addToCartButton: {
            extendedStyles: {
                button: {
                    icon: {
                        position: "left",
                        src: ShoppingCartLine,
                    },
                },
            },
        },
    },
};

const styles = productDetailsAddToCartOptionsAndButtonStyles;

const ProductDetailsAddToCartOptionsAndButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
}: Props) => {
    return (
        <AddToCartOptionsAndButton
            sizeVariant="default"
            buttonSizeVariant="xlarge"
            extendedStyles={{
                ...styles.addToCartOptionAndButton,
                unitOfMeasure: {
                    ...styles.addToCartOptionAndButton?.unitOfMeasure,
                    uid: "unit-of-measure",
                },
                quantityOrdered: {
                    ...styles.addToCartOptionAndButton?.quantityOrdered,
                    id: "qty-ordered",
                    configurationCompleted,
                    variantSelectionCompleted,
                },
                addToCartButton: {
                    ...styles.addToCartOptionAndButton?.addToCartButton,
                    configurationSelection,
                    configurationCompleted,
                    variantSelectionCompleted,
                    "data-test-selector": "addProductToCart",
                },
            }}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToCartOptionsAndButton)),
    definition: {
        displayName: "Add to Cart Options and Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        icon: "cart-circle-plus",
    },
};

export default widgetModule;
